module.exports = __webpack_public_path__ + "img/merge-regular.6d4d34c7.svg";